import Layout from 'components/Layout';
import { Button } from 'components/ui/button';
import { RefreshCw } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store';

const Maintainance = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="flex items-center justify-center rounded-lg bg-background p-10 h-[calc(100vh-100px)] feature-gradient-bg">
        <div className="flex gap-20">
          <img
            src={
              isDarkMode ? '/maintainence-dark.png' : '/maintainence-light.png'
            }
            alt="maintainence"
            className="h-[445px] w-[445px]"
          />
          <div className="flex flex-col gap-9 my-auto w-[457px] text-text-primary">
            <h1 className="text-[80px] leading-none font-bold">
              Under maintenance
            </h1>
            <p className="text-[28px]">
              This feature is under maintenance. Try refreshing the page or{' '}
              <span
                className="text-primary font-semibold underline underline-offset-2 cursor-pointer"
                onClick={() => navigate('/')}
              >
                go back to home
              </span>
              .
            </p>
            <Button
              variant={'customPrimary'}
              className="w-40 rounded-lg"
              onClick={() => window.location.reload()}
            >
              <RefreshCw className="w-5 h-5" />
              Refresh
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Maintainance;
